import { z } from 'zod'

/**
 * Parsed, validated environment variables.
 *
 * All client-exposed env vars MUST be prefixed `VITE_` (Vite contract).
 * Add new variables to the schema *and* `.env.example`.
 */
const EnvSchema = z.object({
  VITE_API_BASE_URL: z.string().default('/api/v1'),
  VITE_WS_URL: z.string().default('/ws'),
  VITE_USE_MOCKS: z
    .union([z.literal('true'), z.literal('false')])
    .default('false')
    .transform((v) => v === 'true'),
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_RELEASE: z.string().default('dev'),
  // Hide the React Query Devtools floating button in dev. Set to
  // 'true' in web/.env.local to keep the screen clean during a demo
  // recording. Always hidden in production builds regardless of
  // this value.
  VITE_HIDE_DEVTOOLS: z
    .union([z.literal('true'), z.literal('false')])
    .default('false')
    .transform((v) => v === 'true'),
  // AF-402 — session inactivity timeout in minutes. The countdown
  // is purely a UX guardrail; backend JWT TTL still governs the
  // hard cut. Defaults match CBN guidance (15 min for high-risk
  // banking operator sessions). Topbar countdown shows when
  // remaining < SESSION_COUNTDOWN_MINUTES; the modal opens when
  // remaining < SESSION_WARNING_MINUTES.
  VITE_SESSION_TIMEOUT_MINUTES: z.coerce.number().min(1).default(15),
  VITE_SESSION_WARNING_MINUTES: z.coerce.number().min(0.5).default(2),
  VITE_SESSION_COUNTDOWN_MINUTES: z.coerce.number().min(1).default(5),
})

const parsed = EnvSchema.safeParse(import.meta.env)
if (!parsed.success) {
  // Fail fast — a missing/invalid env var is unrecoverable.

  console.error('[env] invalid environment variables', parsed.error.flatten().fieldErrors)
  throw new Error('Invalid environment configuration')
}

export const env = parsed.data
